import styled from 'styled-components';
import Typography from '@mui/material/Typography';

export const Price = styled(Typography)`
  font-weight: 500;
  margin-left: 1rem;
`;
